
import React, { useEffect } from "react";
import { useLocation } from "react-router-dom";

function Notifications() {




    const location = useLocation();

  const getQueryParams = () => {
    const params = new URLSearchParams(location.search);

    return {
      title: params.get("title"),
      message: params.get("message"),
      topic: params.get("topic"),
      file: params.get("file")
    };
  };

  const executeFunction = async (data1) => {
    console.log("Title:", data1.title);
    console.log("Message:", data1.message);
    console.log("Topic:", data1.topic);
    console.log("File:", data1.file);

    

const response = await fetch("http://localhost:5000/send-notificaiton", {
    method: "POST",
    headers: {
      "Content-Type": "application/json"
    },
    body: JSON.stringify({
      title: "Mission Gyan",
      body: "New update available",
      topic: "MG111"
    })
  });

  const data = await response.json();

  console.log(data);

    // your logic here
  };

  useEffect(() => {


    
    const data = getQueryParams();
    executeFunction(data);
  }, []);


  return (
    <>
    
<h2>Notification Sent Successfully</h2>
    </>
  );}
  export default Notifications;